
import Ax from './axios'

// const oldApiHost = process.env.oldApiHost

// export function Searching (data) {  // 执行搜索
//     return Ax.post('Faq/Search', {...data}).then(
//         res => res.data
//     )
// }

// export function SearchTagContact (data) {  // 搜索标签联系人
//     return Ax.post('Faq/GetTagContact', {...data}).then(
//         res => res.data
//     )
// }

// export function GetAllTagContact (data) {  // 查看全部联系人
//     return Ax.post('city/GetMoreTagContact', {...data}).then(
//         res => res.data
//     )
// }

// export function SearchFellow (data) {  // 搜索fellow
//     return Ax.post('Faq/SearchFellow', {...data}).then(
//         res => res.data
//     )
// }

// export function Mostly (data) {  // 热度标签
//     return Ax.post('Faq/GetHots', {...data}).then(
//         res => res.data
//     )
// }



/////////////  新版

export function SearchingFaq (data) {  // 搜索FAQ
    return Ax.post('Faq/GetFaqBykeywords', {...data}).then(
        res => res.data
    )
}

export function SearchingAdvice (data) {  // 相似词
    return Ax.post('Similar/List', {...data}).then(
        res => res.data
    )
}

export function SearchingKnowledge (data) {  // 搜索Knowledge
    return Ax.post('Knowledge/GetKnowledgeBykeywords', {...data}).then(
        res => res.data
    )
}

export function SearchingAttachment (data) {  // 搜索附件
    return Ax.post('file/search', {...data}).then(
        res => res.data
    )
}

export function SearchFellow (data) {  // 搜索Fellow
    return Ax.post('Faq/SearchFellow', {...data}).then(
        res => res.data
    )
}

export function GetFaqDetail (data) {  // Faq详情
    return Ax.post('Faq/GetFaqByUUID', {...data}).then(
        res => res.data
    )
}

export function GetKnowledgeDetail (data) {  // Knowledge详情
    return Ax.post('Knowledge/GetKnowledgeDetail', {...data}).then(
        res => res.data
    )
}

export function GetKnowledgeQa (data) {  // Knowledge详情--互动问答
    return Ax.post('Knowledge/GetKnowledgeQa', {...data}).then(
        res => res.data
    )
}

export function GetKnowledgePublish (data) {  // Knowledge详情--互动问答--留言发布
    return Ax.post('Knowledge/GetKnowledgePublish', {...data}).then(
        res => res.data
    )
}



// WEBPACK FOOTER //
// ./src/api/search.js